/**
 * «Smarty Drop» como filtro de la lista: lo que llegó por el Drop, no una columna `channel`.
 *
 * 🐛 LO QUE PASABA (auditoría del 27-sep): la cola Drop del proveedor y del almacén mostraba «Sin
 *    pedidos de Smarty Drop» con 13 ventas esperándolos. Filtraba `channel = 'smartydrop'`, y desde
 *    que la venta es la fila de los cuatro (20260925178000) el encargo —el único con ese canal— se
 *    esconde de las listas. La venta que se ve es la de la tienda, con su canal de siempre.
 *
 * ⭐ LO QUE LLEGA POR EL DROP es la venta de OTRO negocio en la que tengo parte (la lista ya trae sólo
 *    esas: `tenant_id`, `almacen_tenant_id`, `courier_tenant_id` o `proveedor_tenant_id` soy yo), más
 *    el pedido directo de un drop, que sí conserva el canal `smartydrop`.
 *
 * Vive en la consulta compartida (`construirConsultaDePedidos`), así la precarga, la lista, el conteo y
 * la exportación dicen lo mismo.
 */
const CANAL_DEL_DROP = 'smartydrop';

/** El filtro `or` de PostgREST cuando se pide Smarty Drop; `null` si el filtro de canal es el de siempre. */
export function filtroDelDrop(canales: readonly string[], tenantId: string): string | null {
  if (!canales.includes(CANAL_DEL_DROP)) return null;
  return `channel.in.(${canales.join(',')}),tenant_id.neq.${tenantId}`;
}

interface ConsultaConCanal<Q> {
  in(columna: 'channel', valores: string[]): Q;
  or(filtro: string): Q;
}

export function filtrarPorCanal<Q extends ConsultaConCanal<Q>>(consulta: Q, canales: readonly string[], tenantId: string): Q {
  const delDrop = filtroDelDrop(canales, tenantId);
  return delDrop ? consulta.or(delDrop) : consulta.in('channel', [...canales]);
}
